import React from "react";
import { authActions, utils } from "@mc/mc-legacy";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import CardMenu from "../../../components/CardMenu";
import { getAdminMenuItems } from "../../../const/MenuItems";
import "./AdminMenu.scss";
import { connect } from "react-redux";
const { storeFromArea } = utils;
/**
 * Admin menu.
 */

const AdminMenu = () => {
  return (
    <div className="admin-menu">
      <div className="menu menu--pozadavky">
        <CardMenu items={getAdminMenuItems()} title="Administrace" icon={faFileExport} color="#f2c94c" />
      </div>
    </div>
  );
};

export default connect((state, props) => {
  const authInfo = storeFromArea(state, authActions.AUTH_INFO_AREA);
  return {
    isSigner: !authInfo.fetched || authInfo.data.signer,
  };
})(AdminMenu);
